<template>
  <div id='addRemind'>
    <pt-modal :title="$t('deal.dealDetails.dealDetail.dateRemind')" :visible='visible' :width='800' @cancel='hide'
              @ok='submit'
              :loading='loading'>
      <div slot='content'>
        <div class='formDiv'>
          <a-form :form='reminderForm' layout='vertical'>
            <div style='height: 100px'>
              <div v-show='false' v-model='businessId'></div>
              <div v-show='false' v-model='accountIds'></div>
              <div v-show='false' v-model='remindType'></div>
              <div class='title' style='margin-left: 30px;padding-top: 20px'>
                {{ $t('key9genjinpinglvtising') }}
              </div>
              <div style='display: flex;justify-content: space-between;padding-top: 20px'>
                <a-radio-group v-model='remindValue'>
                  <a-radio value='1' class='title' style='width: 50px;margin-left: 30px'>{{ $t('1geyue') }}</a-radio>
                  <a-radio value='3' class='title' style='width: 50px;margin-left: 30px'>{{ $t('3geyue') }}</a-radio>
                  <a-radio value='6' class='title' style='width: 50px;margin-left: 30px'>{{ $t('6geyue') }}</a-radio>
                  <a-radio value='12' class='title' style='width: 50px;margin-left: 30px'>{{ $t('12geyue') }}</a-radio>
                </a-radio-group>
              </div>

            </div>

          </a-form>
        </div>
      </div>
    </pt-modal>
  </div>
</template>

<script>
import reminderApi from '@/api/work/reminder'
import { getDatadictChildsByPath } from '@/api/sys/datadict'
import moment from 'moment'

export default {
  name: 'addRemind',
  props: {
    customerVO: {
      type: Object
    },
    loading: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      businessId:null,
      accountIds:this.$store.getters.userInfo.accountDO.id,
      remindType:10,
      remindValue:null,
    }
  },
  watch: {
    'customerVO.id'() {
      this.init()
    }
  },
  computed: {
    beforeCreate() {
      this.reminderForm = this.$form.createForm(this)
    }
  },
  mounted() {
    if (this.customerVO.id) {
      this.init()
    }
  },
  methods: {
    init() {
      this.businessId = this.customerVO.id
    },
    hide() {
      this.$emit('hide')
    },
    submit() {
      this.loading = true
      console.log(this.remindValue)
      console.log(this.businessId)
      console.log(this.remindType)
      console.log(this.accountIds)
      //提醒时间
      var s = moment(new Date()).add(this.remindValue, 'months').format('YYYY-MM-DD')
      // var reminderDO;
      // reminderDO["businessId"] = this.businessId;
      // reminderDO["accountIds"] = this.accountIds;
      // reminderDO["remindType"] = this.remindType;
      // reminderDO["remindDate"] = s;
      let arr = {businessId:this.businessId,accountIds:[this.accountIds],remindType:this.remindType,startTime:s
      ,advanceDays:1,lastHours:1,taskType:1}
      console.log(arr)
          reminderApi.insert(arr).then(res=>{
            if(res.code == 1){
              this.$emit('saveSuccess')
              this.$message.success(res.message)
            }else{
              this.$message.error(res.message)
            }
          }).finally(()=>{
            this.loading = false
            }
          )
    }
  }
}
</script>

<style scoped lang='less'>
/*.ant-form-item{*/
/*padding: 0 10px;*/
/*}*/
.formDiv {
  background: rgba(248, 249, 251, 0.62);
  border-radius: 4px;
}

.title {
  font-size: 12px;
  color: #999999;
  letter-spacing: 0;
  font-weight: 600;
}
</style>